import { useRecoilState } from 'recoil'
import { currentPlayState } from '../../../../../src/atoms/CurrentPlayAtom'
import { pageState } from '../../../../../src/atoms/PageAtom'
import { pastPageState } from '../../../../../src/atoms/PastPageAtom'

import { useTranslation } from 'react-i18next'

import pauseIcon from '../../../../../src/assets/images/icons/pause.svg'
import playIcon from '../../../../../src/assets/images/icons/play.svg'

type Props = {
  nft: NFT
  shapingPlayList: (target: {
    chainId: number
    tokenId: string
    contractAddress: string
  }) => void
}

type NFT = {
  chain_id: number
  contract_address: string
  token_id: string
  name: string
  image: string
  sound: string
  artist_name: string
  artist_public_id: string
  genres: Genre[]
}

function HomeNft(props: Props) {
  const { t } = useTranslation()

  const [, setPage] = useRecoilState(pageState)
  const [, setPastPage] = useRecoilState(pastPageState)
  const [currentPlay, setCurrentPlay] = useRecoilState(currentPlayState)

  const fixUriPrefix = (uri: string) => {
    let fixUri = String(uri)
    if (fixUri.indexOf('ipfs://') !== -1) {
      fixUri = fixUri.replace('ipfs://', 'https://ipfs.io/ipfs/')
    } else if (fixUri.indexOf('ar://') !== -1) {
      fixUri = fixUri.replace('ar://', 'https://arweave.net/')
    }

    return fixUri
  }

  let networkName = ''
  switch (props.nft.chain_id) {
    case 1:
      networkName = 'ethereum'
      break
    case 5:
      networkName = 'goerli'
      break
    case 137:
      networkName = 'polygon'
      break
  }

  const playMusic = () => {
    if (!props.nft) return

    props.shapingPlayList({
      contractAddress: props.nft.contract_address,
      tokenId: props.nft.token_id,
      chainId: props.nft.chain_id,
    })
  }

  return (
    <div
      className="nft"
      onClick={() => {
        setPastPage('home')
        setPage(
          `nft/${networkName}/${props.nft.contract_address}/${props.nft.token_id}/detail`
        )
      }}
    >
      <div
        className="image"
        style={{ backgroundImage: `url(${fixUriPrefix(props.nft.image)})` }}
        onClick={(event) => {
          event.stopPropagation()
        }}
      >
        <div className="navigation">
          <button className="icon"></button>
          {currentPlay.chainId === props.nft.chain_id &&
          currentPlay.contractAddress === props.nft.contract_address &&
          currentPlay.tokenId === props.nft.token_id &&
          currentPlay.playStatus ? (
            <button
              className="play"
              aria-label="停止"
              style={{ backgroundImage: `url(${pauseIcon})` }}
              onClick={(event) => {
                event.stopPropagation()
                const dupCurrentPlay = Object.assign({}, currentPlay)
                dupCurrentPlay.outerPause = true
                setCurrentPlay(dupCurrentPlay)
              }}
            ></button>
          ) : (
            <button
              className="play"
              aria-label="再生"
              style={{ backgroundImage: `url(${playIcon})` }}
              onClick={(event) => {
                event.stopPropagation()
                playMusic()
              }}
            ></button>
          )}
          <button className="icon"></button>
        </div>
      </div>
      <div className="datum">
        <div className="genres">
          {props.nft.genres.length > 0 ? (
            props.nft.genres.map((genre: Genre) => (
              <button className="genre" key={genre.public_id}>
                {genre.name}
              </button>
            ))
          ) : (
            <button className="genre">ジャンル未設定</button>
          )}
        </div>
        <p className="data ttl">{props.nft.name}</p>
        <button
          className="data button"
          onClick={(event) => {
            event.stopPropagation()
            setPastPage('home')
            setPage(`artists/${props.nft.artist_public_id}`)
          }}
        >
          <span className="user-icon"></span>
          <span className="artist-name">{props.nft.artist_name}</span>
        </button>
      </div>
      {/* <div className="buttons">
        {currentPlay.chainId === props.nft.chain_id &&
        currentPlay.contractAddress === props.nft.contract_address &&
        currentPlay.tokenId === props.nft.token_id &&
        currentPlay.playStatus ? (
          <button
            className="button button-bl"
            onClick={(event) => {
              event.stopPropagation()
              const dupCurrentPlay = Object.assign({}, currentPlay)
              dupCurrentPlay.outerPause = true
              setCurrentPlay(dupCurrentPlay)
            }}
          >
            {t('parts.pauseButton.text')}
          </button>
        ) : (
          <button
            className="button button-bl"
            onClick={(event) => {
              event.stopPropagation()
              playMusic()
            }}
          >
            {t('parts.listeningButton.text')}
          </button>
        )}
        <button
          className="button button-wh"
          onClick={(event) => {
            event.stopPropagation()
            setPastPage('home')
            setPage(
              `nft/${networkName}/${props.nft.contract_address}/${props.nft.token_id}/detail`
            )
          }}
        >
          {t('parts.showButton.text')}
        </button>
      </div> */}
    </div>
  )
}

export default HomeNft
